import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PREPARER, SENDER } from 'signer-app/signature-request/constants';

const messages = defineMessages({
  signature: {
    id: '294d051f877af968cfe9c760c2fc302735368bbb045b399ebc261fa64c8eae23',
    description: 'Alt text for an image of a signature.',
    defaultMessage: 'Signature',
  },
  signatureOfSenderOrPreparer: {
    id: '15444f30e17121bf3b0afcb8da2e5ecbbfbe9531ad767f48346610a8cfeee25a',
    description:
      'Alt text for an image of a signature from either the sender or preparer. Ex. "Signature of document preparer"',
    defaultMessage:
      'Signature of document {signer, select, preparer {preparer} sender {sender} other {signer}}',
  },
  signatureOfSigner: {
    id: 'b0ce8a715b6a9b43d57eb222b61a731e246b7ff0f4c0d2c3443dbe70ed0574df',
    description:
      'Alt text for an image of a signature from a signer with a specific index. Ex. "Signature of Signer 2"',
    defaultMessage: 'Signature of Signer {signer, number}',
  },
});

export const useSignatureImageAlt = ({ signer }: { signer: string }) => {
  const intl = useIntl();

  const msg = useMemo(() => {
    if ([PREPARER, SENDER].includes(signer)) {
      return messages.signatureOfSenderOrPreparer;
    } else if (Number.isInteger(signer)) {
      return messages.signatureOfSigner;
    } else {
      return messages.signature;
    }
  }, [signer]);

  return intl.formatMessage(msg, { signer });
};
